import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app-component';
import 'zone.js';

import { AuthInterceptor } from './app/auth.interceptor';
import { environment } from './environments/environment';

console.log('App bootstrapping with Auth API URL:', environment.authApiBase);
console.log('App bootstrapping with Data API URL:', environment.dataApiBase);

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),

    // IMPORTANT: enable HttpClient + DI-based interceptors
    provideHttpClient(withInterceptorsFromDi()),

    // Register the AuthInterceptor
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },

    importProvidersFrom(FormsModule)
  ]
});
